import { render, staticRenderFns } from "./TravelCard.vue?vue&type=template&id=1733fb0f&scoped=true"
import script from "./TravelCard.vue?vue&type=script&lang=js"
export * from "./TravelCard.vue?vue&type=script&lang=js"
import style0 from "./TravelCard.vue?vue&type=style&index=0&id=1733fb0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1733fb0f",
  null
  
)

export default component.exports